import * as yup from 'yup';
import { parse, isValid, isAfter, isBefore, subYears } from 'date-fns';

yup.addMethod(yup.string, 'isValidCpf', function (message) {
  return this.test({
    message,
    name: 'isValidCpf',
    exclusive: true,
    test(value) {
      const strCPF = value.replace(/\D/g, '').padStart(11, '0');

      let Soma;
      let Resto;

      Soma = 0;
      if (strCPF === '00000000000') {
        return false;
      }

      for (let i = 1; i <= 9; i++) {
        Soma += parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      }

      Resto = (Soma * 10) % 11;

      if (Resto === 10 || Resto === 11) {
        Resto = 0;
      }

      if (Resto !== parseInt(strCPF.substring(9, 10))) {
        return false;
      }

      Soma = 0;

      for (let i = 1; i <= 10; i++) {
        Soma += parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      }

      Resto = (Soma * 10) % 11;

      if (Resto === 10 || Resto === 11) {
        Resto = 0;
      }

      if (Resto !== parseInt(strCPF.substring(10, 11))) {
        return false;
      }

      return true;
    },
  });
});

yup.addMethod(yup.string, 'isValidCep', function (message) {
  return this.test({
    message,
    name: 'isValidCep',
    exclude: true,
    test(value) {
      const cep = String(value).replace(/\D/g, '');
      return cep.length === 8;
    },
  });
});

yup.addMethod(yup.string, 'isValidDate', function (message) {
  return this.test({
    message,
    name: 'isValidaDate',
    exclusive: true,
    test(value) {
      const data = parse(value, 'dd/MM/yyyy', new Date());
      const dataMinima = subYears(new Date(), 18);
      const dataMaxima = subYears(new Date(), 100);

      if (!isValid(data)) {
        return false;
      }

      if (isAfter(data, dataMinima) || isBefore(data, dataMaxima)) {
        return false;
      }

      return true;
    },
  });
});

yup.addMethod(yup.string, 'isTinyName', function (message) {
  return this.test({
    message,
    name: 'isTinyName',
    exclusive: true,
    test(value) {
      const parsedValue = value.trim().split(' ');
      let isValidName = true;

      if (parsedValue.length <= 2) {
        parsedValue.forEach(currentValue => {
          if (currentValue.length < 3) {
            isValidName = false;
          }
        });
      }

      return parsedValue.length >= 2 && isValidName;
    },
  });
});

yup.addMethod(yup.string, 'isCellPhone', function (message) {
  return this.test({
    message,
    name: 'isCellPhone',
    exclusive: true,
    test(value) {
      const parsedValue = value.trim().replace(/\D/g, '');

      // Verifying if it is a cellphone number
      if (parsedValue.length === 11) {
        const ddd = parsedValue.substring(0, 2) * 1;

        // Does not exists DDD smaller than 11 in Brazil
        if (ddd < 11) {
          return false;
        }

        const thisNumber = parsedValue.substring(2);
        const firstDigit = thisNumber.substring(1, 0) * 1;

        if (firstDigit !== 9) {
          // It is not a valid cellphone in Brazil
          return false;
        }

        return true;
      }

      return false;
    },
  });
});

export function getValidationSchema(step) {
  const schemas = {
    login: {
      email: yup
        .string()
        .email('E-mail inválido')
        .required('Informe seu e-mail'),
      password: yup.string().required('Informe sua senha'),
    },
    agent: {
      name: yup
        .string()
        .isTinyName('Please enter agent full name')
        .required('Please enter agent name'),
      email: yup
        .string()
        .email('Please enter a valid email address')
        .required('Please enter an email address'),
      date_of_birth: yup
        .string()
        .isValidDate('Please enter a valid birth date')
        .required('Please enter agent birth date'),
      cep: yup
        .string()
        .isValidCep('Please enter a valid CEP')
        .required('Please enter agent CEP'),
      address: yup.string().required('Please enter agent address'),
      city: yup.string().required('Please enter agent city'),
      state: yup.string().required('Please enter agent state'),
    },
    contact: {
      subject: yup.string().required('Insira o assunto da mensagem'),
      content: yup.string().required('Escreva uma mensagem'),
    },
  };

  return schemas[step];
}
